import { Box } from "@chakra-ui/react";
import { forwardRef } from "react";

interface NativeVideoPlayerProps {
  url: string;
  className?: string;
}

/**
 * Renders an HTML5 <video> element for self-hosted MP4/WebM files.
 */
const NativeVideoPlayer = forwardRef<HTMLVideoElement, NativeVideoPlayerProps>(({
  url,
  className,
}, ref) => {
  return (
    <Box
      className={className}
      w="full"
      h="full"
      borderRadius="intermediate"
      sx={{
        "&:focus-within": { outline: "2px solid", outlineColor: "blue.500" },
      }}
    >
      <video
        ref={ref}
        src={url}
        controls
        playsInline
        preload="none"
        style={{ width: "100%", height: "100%", display: "block", borderRadius: "inherit" }}
      />
    </Box>
  );
});

export default NativeVideoPlayer;
